module.exports = __webpack_public_path__ + "img/client_logo_6.a3c6d1c4.png";